module.exports = __webpack_public_path__ + "static/media/hands.59f4844c.jpg";